import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import { useTranslations } from "next-intl";

import { DeliveryServiceIcon, OfficeIcon } from "@/components/assets/icons";
import { PlaceOfDelivery } from "@/enums";

const deliveryIcons: Record<PlaceOfDelivery, ReactNode> = {
  [PlaceOfDelivery.OFFICE]: <OfficeIcon />,
  [PlaceOfDelivery.COURIER]: <DeliveryServiceIcon className="primary-color" />,
};

type TProps = {
  mode: PlaceOfDelivery;
  address: string;
};

const DeliveryPlace: FC<TProps> = ({ mode, address }) => {
  const t = useTranslations();

  return (
    <div className="flex flex-row items-center gap-3">
      <div
        className={classNames(
          "flex h-11 w-11 items-center justify-center rounded-full bg-[#f9f9f9]",
          {
            "secondary-bg": mode === PlaceOfDelivery.COURIER,
          },
        )}
      >
        {deliveryIcons[mode]}
      </div>
      <div>
        <p className="text-sm font-medium">{t(mode)}</p>
        <p className="text-xs text-[#9a9a9a]">{address}</p>
      </div>
    </div>
  );
};

export { DeliveryPlace };
